var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMobileFirstStepIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 68,
    height: 32,
    viewBox: "0 0 68 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.5 5C0.5 2.51472 2.51472 0.5 5 0.5H60C60.37 0.5 60.727 0.636857 61.002 0.884245L67.5 16L61.002 31.1158C60.727 31.3631 60.37 31.5 60 31.5H5C2.51472 31.5 0.5 29.4853 0.5 27V5Z",
    stroke: "#39BAFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobileFirstStepIcon);
export default __webpack_public_path__ + "static/media/mobile-first-step-icon.9f08ba234dec73e57b2df85ad3438fb7.svg";
export { ForwardRef as ReactComponent };